<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-group label-for="input-email">
      <template #label>
        Email
      </template>
      <b-form-input id="input-email" v-model="form.email" :state="isValidField('email')" placeholder="eg., yourname@company.com" class="rounded-pill" />
      <b-form-invalid-feedback :state="isValidField('email')">
        <div v-for="error in errors.email || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="input-password">
      <template #label>
        <b-row no-gutters>
          <b-col>
            Password
          </b-col>
          <b-col cols="auto" class="align-self-end mr-2">
            <h6 class="m-0">
              <b-link href class="btn-link-dark" tabindex="-1" @click.prevent.stop="showPwd">
                <keep-alive>
                  <component :is="eyeIcon" font-scale="1.3" class="mr-2" />
                </keep-alive>
                <template v-if="showPass">Hide</template>
                <template v-else>Show</template>
              </b-link>
            </h6>
          </b-col>
        </b-row>
      </template>
      <b-form-input
        id="input-password"
        :type="passwordType"
        v-model="form.password"
        :state="isValidField('password')"
        placeholder="Password"
        class="rounded-pill"
      />
      <b-form-invalid-feedback :state="isValidField('password')">
        <div v-for="error in errors.password || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
      <!-- <b-form-checkbox v-model="form.remember" class="mt-2 ml-2">
        Remember me
      </b-form-checkbox> -->
    </b-form-group>
    <b-form-invalid-feedback :state="isValidField(['detail', 'companySlug'])">
      <div v-for="error in getErrors(['detail', 'companySlug']) || []" :key="error">
        {{ error }}
      </div>
    </b-form-invalid-feedback>
    <b-form-row class="mt-5 justify-content-center">
      <b-col cols="auto">
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">Login</b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import validator from 'validator'
import { BIconEyeFill, BIconEyeSlashFill } from 'bootstrap-vue'
import MixinForm from './MixinForm'

export default {
  name: 'SignInForm',

  mixins: [MixinForm],

  props: {
    companySlug: {
      type: String
    }
  },

  computed: {
    passwordType() {
      return this.showPass ? 'text' : 'password'
    },

    eyeIcon() {
      return this.showPass ? BIconEyeSlashFill : BIconEyeFill
    }
  },

  data() {
    return {
      form: {
        email: '',
        password: ''
        // remember: false
      },
      showPass: false
    }
  },

  methods: {
    showPwd() {
      this.showPass = !this.showPass
    },

    validate(data) {
      const errors = {}
      if (validator.isEmpty(data.email)) errors.email = ["Email can't be blank"]
      if (validator.isEmpty(data.password)) errors.password = ["Password can't be blank"]
      return errors
    },

    onSubmit() {
      this.errors = this.validate(this.form) || {}
      if (this.isValid) {
        const data = { ...this.form, companySlug: this.companySlug }
        this.$emit('submit', data)
      }
    }
  }
}
</script>
